<template>
    <v-container fluid>
        <!--table head-->
        <v-row justify="end">
            <information :text="`${text[locale.split('-')[0]]}`" />
        </v-row>
        <v-divider color="black"/>

        <v-row class="subtitle-2" no-gutters>
            <v-col cols="2"></v-col>
            <v-divider vertical color="black"></v-divider>                  
            <v-col cols="5" class="text-center">{{'Consumers design type preferences' | localize }}</v-col>
            <v-divider vertical color="black"></v-divider>
            <v-col cols="5" class="text-center">{{'Consumers design quality preferences' | localize }}</v-col>
        </v-row>
        <v-divider color="black"/>
        <v-row class="subtitle-2 text-center" no-gutters>
            <v-col class="text-left" cols="2">{{'Segment' | localize }}</v-col>
            <v-divider vertical color="black"></v-divider>
            <v-col  v-for="(item, i) in types" :key="`type-${i}`"
                cols="1">
                {{ item }}
            </v-col>
            <v-divider vertical color="black"></v-divider>
            <v-col v-for="i in 5" :key="i"
                cols="1">
                {{'Level' | localize }} {{ i }}
            </v-col>
        </v-row>
        <v-divider color="black"/> 

        <div v-if="market_segments.length">
            <!--segments tab-->
            <div v-for="segment in market_segments" :key="segment.id">
                <v-row class="body-2 my-1" no-gutters>
                    <v-col cols="2" class="text-left text-truncate">{{ segment.segment.name }}</v-col>
                    <v-divider vertical></v-divider>
                    <v-col class="text-center">{{ Math.round(segment.design_classic * 100) }}%</v-col>
                    <v-col class="text-center">{{ Math.round(segment.design_business * 100) }}%</v-col>
                    <v-col class="text-center">{{ Math.round(segment.design_casual * 100) }}%</v-col>
                    <v-col class="text-center">{{ Math.round(segment.design_innovative * 100) }}%</v-col>
                    <v-col class="text-center">{{ Math.round(segment.design_art * 100) }}%</v-col>
                    <v-divider vertical></v-divider>
                    <v-col class="text-center">{{ Math.round(segment.design_1 * 100) }}%</v-col>
                    <v-col class="text-center">{{ Math.round(segment.design_2 * 100) }}%</v-col>
                    <v-col class="text-center">{{ Math.round(segment.design_3 * 100) }}%</v-col>
                    <v-col class="text-center">{{ Math.round(segment.design_4 * 100) }}%</v-col>
                    <v-col class="text-center">{{ Math.round(segment.design_5 * 100) }}%</v-col>
                </v-row>
                <v-divider />
            </div>
        </div>
    </v-container>
</template>
<script>
import Information from '../../../layouts/Information.vue';

export default {
    name: 'MarketDesign',
    data() {
        return {
            types: ['Classic', 'Business', 'Casual', 'Innovative', 'Art'],
            text: {
                en: 'This report shows product design preferences within each market segment.',
                ro: 'Acest raport prezintă preferințele în ceea ce privește designul produselor în fiecare segment de piață',
                ru: 'В данном отчете представлены предпочтения в отношении дизайна продукции в каждом сегменте рынка'
            },
        }
    },
    computed: {
        locale() {
            return this.$store.getters.locale;
        },
        market_segments() {
            return this.$store.getters.market_segments
        },
        game() {
            return this.$store.getters.game
        }
    },
    components: { Information },
}
</script>